import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService } from '@patsnap/tahiti-core';
import type { AddProApi } from '../add-pro-api';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';

@injectable()
export class AddProApiImpl extends PsHttpService implements AddProApi {
    get options() {
        return {
            baseURL: '/api',
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    async addProPkg(): Promise<void> {
        await this.post({
            url: 'user-capacity/add-pro-trial',
            baseURL: coreTelecomApiUrlPrefix,
        });
    }
}
